import * as React from 'react';


export default function Taxation() {


    return (
        <div>
            <p>Taxation</p>
        </div>
    );
}
